<template>
  <path d="M19 24h-14v-16l-2 1.084-3-3.612 6-5.472h12l6 5.505-3 3.647-2-1.152v16zm-11-23h8c-.365 1.846-1.792 3.5-4 3.5s-3.635-1.708-4-3.5z"/>
</template>

<script>
export default {
  name: 'IconClothes'
}
</script>



// WEBPACK FOOTER //
// src/components/icons/IconClothes.vue